import { BaseService } from './base'
import { APIPath } from 'utility/constant'

const assertSuccess = result => {
    if (result && result.Success === false) {
        const error = new Error(result.ErrorMessage || 'Request failed')
        error.error = result
        throw error
    }
    return result
}

class ReasonPresetServiceClass {
    getByTemplate(templateId) {
        return BaseService.get(
            `${APIPath.reasonPreset}?templateId=${encodeURIComponent(templateId)}`,
        ).then(assertSuccess)
    }

    generate({ TemplateId, QuestionUId = null, Force = false }) {
        return BaseService.postExact(APIPath.reasonPresetGenerate, {
            TemplateId,
            QuestionUId,
            Force: !!Force,
        }).then(assertSuccess)
    }

    saveReasons({ TemplateId, QuestionUId, TriggerResponseUId, Reasons }) {
        return BaseService.postExact(APIPath.reasonPresetSave, {
            TemplateId,
            QuestionUId,
            TriggerResponseUId,
            Reasons,
        }).then(assertSuccess)
    }

    getSetting(templateId) {
        const query =
            templateId == null
                ? ''
                : `?templateId=${encodeURIComponent(templateId)}`
        return BaseService.get(`${APIPath.reasonPresetSetting}${query}`).then(
            assertSuccess,
        )
    }

    saveSetting(payload) {
        return BaseService.postExact(
            APIPath.reasonPresetSettingSave,
            payload,
        ).then(assertSuccess)
    }

    saveSelection({ AuditId, AuditQuestionId, Selections }) {
        return BaseService.postExact(APIPath.reasonPresetSelectionSave, {
            AuditId,
            AuditQuestionId,
            Selections,
        }).then(assertSuccess)
    }
}

export const ReasonPresetService = new ReasonPresetServiceClass()
